import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api"; // Import your custom API service
import "./Inactive.css";

const InactiveEmployees = () => {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id: businessId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch inactive employees when the component loads
        const fetchInactiveEmployees = async () => {
            try {
                const response = await api.get(`/employees/${businessId}/inactive`);

                setEmployees(response.data); // Assuming `response.data` holds the employee list
            } catch (err) {
                setError("Failed to fetch employees.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchInactiveEmployees();
    }, [businessId]);

    const enableEmployee = async (employeeId) => {
        try {
            await api.put(`/employees/${employeeId}/enable`);

            // Remove the enabled employee from the list
            setEmployees((prevEmployees) =>
                prevEmployees.filter((employee) => employee.id !== employeeId)
            );
        } catch (err) {
            console.error("Failed to enable employee:", err);
            alert("Error enabling employee.");
        }
    };

    if (loading) return <p>Loading employees...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div>
            <h5 className="inactive-header">Inactive Employees</h5>
            <button
                className="back-btn"
                onClick={() => navigate(`/dashboard/business/${businessId}/employees`)}
            >
                Back
            </button>
            {employees.length === 0 ? (
                <p className="inactive-message">No inactive employees found.</p>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>City</th>
                            <th>Disabled on</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employees.map((employee) => (
                            <tr key={employee.id}>
                                <td>{employee.first_name}</td>
                                <td>{employee.last_name}</td>
                                <td>{employee.e_city}</td>
                                <td>{employee.disabled_at}</td>
                                <td>
                                    <button onClick={() => enableEmployee(employee.id)}>
                                        Enable
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default InactiveEmployees;
